'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusOnMount = focusOnMount;
exports.selectOnMount = selectOnMount;

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Focus a ref’d react input when it is mounted
 * @param ref
 */
function focusOnMount(ref) {
  var el = _reactDom2.default.findDOMNode(ref);

  if (el) {
    // Give focus and put the cursor at the end of
    // the value.
    el.focus();
    el.value = el.value;
  }
}

/**
 * Select the text of a ref’d react input when it is mounted
 * @param ref
 */
function selectOnMount(ref) {
  if (ref && ref.select) {
    ref.select();
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/utils/react.js
// module id = 363
// module chunks = 114276838955818